import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconMediaPlay = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#ffffff',
    width = '100%',
    height = '100%',
    viewBox = '0 0 16 16',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06461 15.033C3.73131 15.2303 3.30996 14.99 3.30996 14.6027L3.30996 1.36433C3.30996 0.979506 3.72648 0.738934 4.05981 0.931238L15.3869 7.46598C15.7183 7.65716 15.721 8.13451 15.3917 8.32936L4.06461 15.033Z",
    fill: fill
  })));
});

export { IconMediaPlay as default };
